export default {
  footer: {
    tagline: '世界中の人が相互理解を深める透明でフェアな社会',
    home: 'HOME',
    aboutUs: '会社概要',
    philosophy: '企業理念',
    ourBusiness: '事業内容',
    news: 'ニュース',
    contacts: 'お問合せ',
    chemicalList: '化学品リスト',
    exportTerms: '貿易用語集',
    purchaseProcess: '輸出手続きの流れ',
    companyProfile: '企業情報',
    history: '沿革',
    missionStatement: 'ミッション',
    coreValues: 'コアバリュー',
    tradingServices: '貿易サービス',
    importExportTerms: '貿易用語集',
    chemicalTradeInfo: '化学品貿易情報',
    productList: '化学品リスト',
    latestNews: 'ニュース',
    contactForm: 'お問合せ',
    purchasingProcess: '輸出手続きの流れ',
    copyright: 'Copyright © 2026 Daishin Corporation. All Rights Reserved',
    sitePolicy: 'サイトポリシー',
    privacyPolicy: 'プライバシーポリシー',
    infoSecurityPolicy: '情報セキュリティポリシー',
  },
};
